"use strict";
/**
 * Credentials Modal Handler
 *
 * Manages the API-credentials modal:
 * - Open / close / overlay-dismiss
 * - Validates that an access key is provided
 * - Stores credentials and triggers a market reload on success
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupCredentialsModal = setupCredentialsModal;
const ui_1 = require("../../ui");
const auth_1 = require("../../auth");
const events_handler_1 = require("../events-handler");
/**
 * Wire up all event listeners for the API credentials modal.
 * Called once from `initApp`.
 */
function setupCredentialsModal() {
    const closeBtn = document.getElementById("close-credentials-modal");
    const cancelBtn = document.getElementById("cancel-credentials-btn");
    const form = document.getElementById("credentials-form");
    const overlay = document.querySelector(".credentials-modal-overlay");
    // --- Close / cancel / overlay dismiss ---
    if (closeBtn) {
        closeBtn.addEventListener("click", () => (0, ui_1.hideCredentialsModal)());
    }
    if (cancelBtn) {
        cancelBtn.addEventListener("click", () => (0, ui_1.hideCredentialsModal)());
    }
    if (overlay) {
        overlay.addEventListener("click", (e) => {
            if (e.target === overlay)
                (0, ui_1.hideCredentialsModal)();
        });
    }
    // --- Form submission ---
    if (form) {
        form.addEventListener("submit", (e) => {
            e.preventDefault();
            try {
                const credentials = (0, ui_1.getCredentialsFormValues)();
                if (!credentials.accessKey.trim()) {
                    (0, ui_1.showError)("Access Key is required", "credentials-error");
                    return;
                }
                // Store credentials
                if ((0, auth_1.storeApiCredentials)({
                    accessKey: credentials.accessKey,
                })) {
                    (0, ui_1.hideCredentialsModal)();
                    (0, ui_1.showError)("Credentials saved successfully!", "market-error");
                    setTimeout(() => (0, ui_1.hideError)("market-error"), 2000);
                    // Load markets with new credentials
                    setTimeout(() => (0, events_handler_1.loadEvents)(), 500);
                }
            }
            catch (error) {
                console.error("Error saving credentials:", error);
                (0, ui_1.showError)("Failed to save credentials", "credentials-error");
            }
        });
    }
}
